module.exports = __webpack_public_path__ + "img/Texture_Black.5ae71b77.svg";